import $ from "superagent";
import { Feature } from "geojson";
import { OPENCAGEDATA_ENDPOINT, OPENCAGEDATA_KEY } from "../constants";

interface OpencageForwardGeocodeResponse {
  body: {
    features: Feature[];
  };
}

export interface OpencageGeocodeResult {
  geoJSON: Feature;
  title: string;
}

let geocodeRequest: $.SuperAgentRequest | null = null;
export default function forwardGeocode(
  address: string,
): Promise<OpencageGeocodeResult[]> {
  if (geocodeRequest) {
    geocodeRequest.abort();
  }

  geocodeRequest = $.get(OPENCAGEDATA_ENDPOINT).query({
    q: address,
    key: OPENCAGEDATA_KEY,
    no_annotations: 1,
  });

  return geocodeRequest
    .then(({ body }: OpencageForwardGeocodeResponse) => {
      return body.features.map(feature => ({
        title: feature.properties != null ? feature.properties.formatted : "",
        geoJSON: feature,
      }));
    })
    .catch(err => {
      console.error("Geocoding failed:", err);
      throw err;
    });
}
